import React                from "react";
import PropTypes            from "prop-types";
import { connect }          from "react-redux";
import { Coach }            from "Utils/API";
import Status               from "dashboard/dist/Core/Status";
import Utils                from "dashboard/dist/Utils/Utils";

// Components
import EditDialog           from "dashboard/dist/Components/EditDialog";
import Columns              from "dashboard/dist/Components/Columns";
import InputField           from "dashboard/dist/Components/InputField";

// Actions
import {
    fetchChatEdit, fetchChatCreate, editChat,
} from "Actions/Admin/Strech/ChatActions";



/**
 * The Strech Chat Edit Dialog
 */
class ChatEdit extends React.Component {
    // The Initial Data
    initialData = {
        strechChatID   : 0,
        strechID       : 0,
        credentialID   : 0,
        coachID        : 0,
        coachName      : "",
        name           : "",
        description    : "",
        videoLink      : "",
        streamLink     : "",
        streamPassword : "",
        timeDate       : "",
        fromHour       : "",
        toHour         : "",
        status         : Status.getID("ACTIVE"),
        observations   : "",
    }

    // The Current State
    state = {
        loading : false,
        data    : { ...this.initialData },
        errors  : {},
    }



    /**
     * Get the Data when the Element ID changes
     * @param {Object} prevProps
     * @returns {Void}
     */
    componentDidUpdate(prevProps) {
        const { open, edition, elemID, elem, strechID, coaches, fetchChatEdit, fetchChatCreate } = this.props;
        let loading = false;
        let data    = null;

        // Dialog Opens
        if (open && !prevProps.open) {
            data = { ...this.initialData };
            // Load new data
            if (elemID) {
                fetchChatEdit(elemID);
                loading = true;
            // Load edit data
            } else if (strechID) {
                fetchChatCreate(strechID);
                loading = true;
            }

        // Data Updated
        } else if (prevProps.edition !== edition) {
            if (elemID) {
                data = Utils.extend(this.initialData, elem);
                const name = Utils.getValue(coaches, "key", elem.credentialID, "value");
                if (!name) {
                    data.coachID   = elem.credentialID;
                    data.coachName = elem.credentialName;
                }
            } else {
                data = { ...this.initialData, strechID };
            }
        }

        // Set the State
        if (data) {
            this.setState({ data, loading, errors : {} });
        }
    }

    /**
     * Handles the Input Change
     * @param {String} name
     * @param {*}      value
     * @returns {Void}
     */
    handleChange = (name, value) => {
        this.setState({
            data   : { ...this.state.data,   [name] : value },
            errors : { ...this.state.errors, [name] : ""    },
        });
    }

    /**
     * Handles the Submit
     * @returns {Promise}
     */
    handleSubmit = async () => {
        const { data, loading } = this.state;
        if (!loading) {
            this.setState({ loading : true, errors : {} });
            try {
                await this.props.editChat(data);
                this.setState({ loading : false });
                this.props.onSubmit();
            } catch (errors) {
                this.setState({ loading : false, errors });
            }
        }
    }



    /**
     * Does the Render
     * @returns {Object}
     */
    render() {
        const { elemID, open, onClose, isVirtual, coaches } = this.props;
        const { data, loading, errors                     } = this.state;

        return <EditDialog
            open={open}
            icon="chat"
            title={!!elemID ? "CHATS_EDIT_TITLE" : "CHATS_CREATE_TITLE"}
            error={errors.form}
            onSubmit={this.handleSubmit}
            onClose={onClose}
            isLoading={loading}
        >
            <InputField
                name="name"
                label="CHATS_ITS_NAME"
                value={data.name}
                error={errors.name}
                onChange={this.handleChange}
                isRequired
            />
            <InputField
                type="textarea"
                name="description"
                label="CHATS_DESCRIPTION"
                value={data.description}
                error={errors.description}
                onChange={this.handleChange}
            />
            <InputField
                name="videoLink"
                label="CHATS_VIDEO"
                value={data.videoLink}
                error={errors.videoLink}
                onChange={this.handleChange}
            />
            <Columns>
                <InputField
                    isHidden={!isVirtual}
                    type="string"
                    name="streamLink"
                    label="GENERAL_STREAM_LINK"
                    value={data.streamLink}
                    error={errors.streamLink}
                    onChange={this.handleChange}
                    isRequired
                />
                <InputField
                    isHidden={!isVirtual}
                    type="string"
                    name="streamPassword"
                    label="GENERAL_STREAM_PASSWORD"
                    value={data.streamPassword}
                    error={errors.streamPassword}
                    onChange={this.handleChange}
                />

                <InputField
                    type="select"
                    name="credentialID"
                    label="CHATS_COACH"
                    value={data.credentialID}
                    error={errors.credentialID}
                    onChange={this.handleChange}
                    options={coaches}
                    withNone
                />
                <InputField
                    name="coachName"
                    label="CHATS_COACH_SEARCH"
                    suggestID="coachID"
                    suggestFetch={Coach.search}
                    suggestNone="COACHES_NONE_AVAILABLE"
                    value={data.coachName}
                    error={errors.coachID}
                    onChange={this.handleChange}
                    isRequired
                />
            </Columns>
            <InputField
                type="date"
                name="timeDate"
                label="CHATS_DATE"
                value={data.timeDate}
                error={errors.timeDate}
                onChange={this.handleChange}
                isRequired
            />
            <Columns>
                <InputField
                    type="time"
                    name="fromHour"
                    label="GENERAL_FROM_HOUR"
                    value={data.fromHour}
                    error={errors.fromHour}
                    onChange={this.handleChange}
                />
                <InputField
                    type="time"
                    name="toHour"
                    label="GENERAL_TO_HOUR"
                    value={data.toHour}
                    error={errors.toHour}
                    onChange={this.handleChange}
                />
            </Columns>
            <InputField
                type="select"
                name="status"
                label="GENERAL_STATUS"
                value={data.status}
                error={errors.status}
                onChange={this.handleChange}
                options={Status.getFemSelect("STRECH")}
                withNone
                isRequired
                shrinkLabel
            />
            <InputField
                type="textarea"
                name="observations"
                label="GENERAL_OBSERVATIONS"
                value={data.observations}
                onChange={this.handleChange}
            />
        </EditDialog>;
    }



    /**
     * The Property Types
     * @typedef {Object} propTypes
     */
    static propTypes = {
        fetchChatEdit   : PropTypes.func.isRequired,
        fetchChatCreate : PropTypes.func.isRequired,
        editChat        : PropTypes.func.isRequired,
        open            : PropTypes.bool.isRequired,
        onClose         : PropTypes.func.isRequired,
        onSubmit        : PropTypes.func.isRequired,
        edition         : PropTypes.number.isRequired,
        isVirtual       : PropTypes.bool.isRequired,
        coaches         : PropTypes.array.isRequired,
        elem            : PropTypes.object.isRequired,
        elemID          : PropTypes.number,
        strechID        : PropTypes.number,
    }

    /**
     * Maps the State to the Props
     * @param {Object} state
     * @returns {Object}
     */
    static mapStateToProps(state) {
        return {
            edition   : state.strechChat.edition,
            isVirtual : state.strechChat.isVirtual,
            coaches   : state.strechChat.coaches,
            elem      : state.strechChat.elem,
        };
    }
}

export default connect(ChatEdit.mapStateToProps, {
    fetchChatEdit, fetchChatCreate, editChat,
})(ChatEdit);
